<template>
  <div class="container">
    <div class="left">
      <div
        :class="[{ 'left-item': true }, { 'item-active': id == item.id }]"
        v-for="item in project"
        :key="item.id"
        @click="switchProject(item.id)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="right">
      <div class="header">
        <div
          :class="['purchase', { active: type == 1 }]"
          @click="switchType(1)"
        >
          待抽查
        </div>
        <div
          :class="['purchase', { active: type == 2 }]"
          @click="switchType(2)"
        >
          抽查记录
        </div>
      </div>
      <div class="search">
        <el-form :inline="true" style="text-align: left">
          <el-form-item label="订单名称：">
            <el-input
              v-model="search.orderName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="申请人：">
            <el-input v-model="search.createBy" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="select">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-show="type == 1"
        height="59vh"
      >
        <el-table-column
          label="序号"
          type="index"
          :index="indexMethod"
          width="80"
        >
        </el-table-column>
        <el-table-column prop="orderName" label="订单名称">
          <template slot-scope="scope">
            <span>{{ scope.row.orderName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="订单编号">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createBy" label="申请人">
          <template slot-scope="scope">
            <span>{{ scope.row.createBy }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="提交时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">待提交</span>
            <span v-if="scope.row.status == 1" style="color: #fdce40"
              >等待审核</span
            >
            <span v-if="scope.row.status == 2">审核通过</span>
            <span v-if="scope.row.status == 3" style="color: #ff3535"
              >审核不通过</span
            >
          </template>
        </el-table-column>
       
        <el-table-column prop="date" label="审批人">
          <template slot-scope="scope">
            <span>{{ scope.row.examineBy }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="审批时间">
          <template slot-scope="scope">
            <span>{{ scope.row.examineDate }}</span>
          </template>
        </el-table-column>
         <el-table-column label="是否通过">
          <template slot-scope="scope">
            <span v-if="scope.row.spotCheck == '1'" style="color: green">通过</span>
            <span v-if="scope.row.spotCheck == '2'" style="color: red">不通过</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="date" label="清单">
          <template slot-scope="scope">
            <span>{{ scope.row }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="date" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="check(scope.row)">去抽查</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-table
        :data="recordData"
        border
        style="width: 100%"
        v-show="type == 2"
        height="59vh"
      >
        <el-table-column
          prop="date"
          label="序号"
          type="index"
          :index="indexMethod"
          width="80"
        >
        </el-table-column>
        <el-table-column prop="date" label="项目名称">
          <template slot-scope="scope">
            <span>{{ scope.row.projectName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="订单名称">
          <template slot-scope="scope">
            <span>{{ scope.row.plannedPurchaseName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="抽查时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.spotCheck == '1'" style="color: green">审核通过</span>
             <span v-if="scope.row.spotCheck == '2'" style="color: red">审核不通过</span>
          </template>
        </el-table-column>
         <!-- <el-table-column prop="date" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="look(scope.row)">查看</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <el-dialog :title="title" :visible.sync="checkDialog" width="60%">
        <div class="box">
          <el-table :data="dialogTableData" border style="width: 100%"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="date" label="名称">
              <template slot-scope="scope">
                <span>{{ scope.row.productName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="品牌">
              <template slot-scope="scope">
                <span>{{ scope.row.brand }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="规格">
              <template slot-scope="scope">
                <span>{{ scope.row.productSpecs }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="date" label="单位">
              <template slot-scope="scope">
                <span>{{ scope.row }}</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="date" label="数量">
              <template slot-scope="scope">
                <span>{{ scope.row.productCount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="资质">
              <template slot-scope="scope">
                <span>{{ scope.row.materialQualification }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="request">
            <span style="margin-right: 3vw">材料是否合格？</span>
            <el-radio v-model="radio" label="1">合格</el-radio>
            <el-radio v-model="radio" label="2">不合格</el-radio>
          </div>
          <div class="reason">
            <div style="width: 8vw; text-align: left">上传报告:</div>
            <el-card class="card">
              <el-upload
                class="upload-demo"
                :action="uploadFile"
                :data="uploadData"
                :on-remove="handleRemove"
                multiple
                :headers="header"
                :show-file-list="true"
                :on-success="fileSuccess"
                :file-list="fileList"
              >
                <el-button type="primary" size="small"
                  >上传报告<i class="el-icon-upload el-icon--right"></i
                ></el-button>
              </el-upload>
            </el-card>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="checkDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitForm"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import base from '../../../untils/base'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
export default {
  data() {
    return {
      id: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      checkDialog: false,
      type: 1, //控制材料管理和抽查记录
      radio: '',
      tableData: [],
      recordData: [],
      search: {
        orderName: '',
        createBy: '',
      },
      project: [],
      dialogTableData: [],
      title: '',
      checked: [],
      uploadFile: myHttp.uploadFile,
      header: {
        accessToken: util.session.get('token')
      },
      uploadData: {
        type: '232'
      },
      fileList: [],
      orderId: ''
    }
  },
  mounted() {
    this.getAll()
  },
  methods: {
    select(){
      if(type == '1'){
        this.getData()
      }
      if(type == '2'){
        this.getData2()
      }
    },
     //获取项目
    getAll() {
      myHttp
        .getProjectListByEntIdAndJoinType({
          entId: util.session.get('groupId'),
        })
        .then(resp => {
          console.log(resp);
          if (resp.data.code == '200') {
            this.project = resp.data.data.list || []
            this.id = resp.data.data.list[0].id
            this.getData()
          }
        })
    },
    //  获取数据
    getData() {
      myHttp
        .getPlannedPurchaseList({
          projectId: this.id,
          orderName: this.search.orderName,
          createBy: this.search.createBy,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        })
        .then((resp) => {
          console.log(resp)
          if (resp.data.code == '200') {
            this.tableData = resp.data.data.list
            this.total = resp.data.data.total
          }
        })
    },
    // 抽查记录
    getData2() {
      myHttp.getSpotCheckRecordList({
        projectId: this.id,
        plannedPurchaseName: this.search.orderName,
        createBy: this.search.createBy,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(resp => {
        console.log(resp);
        if(resp.data.code =='200'){
          this.recordData = resp.data.data.list
          this.total = resp.data.data.total
        }
      })
    },
     // 查看
      look(row){
        this.checkDialog = true
        this.dialogTableData = []
        this.radio = ''
        myHttp.getSpotCheckRecorddetail({
          projectId: this.id,
          id: row.id
        }).then(resp => {
          console.log(resp);
          if(resp.data.code == '200'){
            this.dialogTableData = resp.data.data.plannedPurchaseDetailList || []
            let status = resp.data.data.status
            if(status == '2'){
              this.radio = '1'
            }
            if(status == '3'){
              this.radio = '2'
            }
          }
        })
      },
    switchType(index) {
      this.type = index
      if(index == '1'){
        this.getData()
      }
      if(index == '2'){
        this.getData2()
      }
    },
    switchProject(id) {
      this.id = id
       if (this.type == '1') {
        this.getData()
      }
      if (this.type == '2') {
        this.getData2()
      }
    },
    //  点击抽查
    check(row) {
      this.checkDialog = true
      this.orderId = row.id
      this.title = row.orderName
      this.fileList = []
      myHttp.getPlannedPurchaseDetailById({
        id: row.id
      }).then(resp => {
        console.log(resp);
        if(resp.data.code == '200'){
          this.dialogTableData = resp.data.data
        }
      })
    },
    //  选择表格
    handleSelectionChange(val){
      console.log(val);
      this.checked = val
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      if (this.type == '1') {
        this.getData()
      }
      if (this.type == '2') {
        this.getData2()
      }
    },
    //  ///////
    submitForm(){
      let isArray = ''
      console.log(this.checked);
      this.checked.forEach(item => {
        isArray = isArray+ ',' + item.detailId
      })
      isArray = isArray.slice(1)
      let fileUrl = ''
      console.log(this.fileList);
      this.fileList.forEach(item => {
        fileUrl = fileUrl + ',' + item.response.data.saveUrls;
      })
      fileUrl = fileUrl.slice(1)
      myHttp.spotCheck({
        projectId: this.id,
        id: this.orderId,
        idArray: isArray,
        spotCheck: this.radio,
        fileUrl: fileUrl
      }).then(resp => {
        console.log(resp);
        if(resp.data.code == '200'){
           this.$message.success('操作成功')
           this.checkDialog = false
           this.getData()
        }else{
          this.$message.error(resp.data.msg)
        }
      })
    },
    fileSuccess(resp,file,fileList) {
      console.log(resp);
      console.log(fileList);
      if(resp.code == '200'){
        this.fileList = fileList
      }
    },
    handleRemove(file, fileList){
      this.fileList = fileList
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.pageNum = val
      if (this.type == '1') {
        this.getData()
      }
      if (this.type == '2') {
        this.getData2()
      }
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + 1 + index
    },
  },
}
</script>

<style scoped>
.container {
  height: 100%;
  background-color: #fff;
  display: flex;
}
.left {
  width: 13%;
  height: 100%;
  border-right: 1px solid #ccc;
  padding-top: 1vh;
  overflow-y: scroll;
}
.left-item {
  height: 6vh;
  line-height: 6vh;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-active {
  background-color: #f5f5f5;
}
.right {
  padding: 1vh 1vw;
  width: 86%;
}
.header {
  display: flex;
  border-bottom: 4px solid #f5f5f5;
}

.purchase {
  padding: 2vh 2vw;
  cursor: pointer;
}

.active {
  color: #003d9c;
  border-bottom: 4px solid #003d9c;
}

.search {
  margin: 2vh 0;
}
.request {
  margin-top: 4vh;
  text-align: left;
}
.reason {
  margin-top: 2vh;
  display: flex;
}
.card {
  width: 100%;
  height: 20vh;
}
.upload-demo {
  text-align: left;
}
.container >>> .el-dialog__header{
  text-align: left;
  font-weight: 900;
}
</style>